import React from "react";
import { Eye, Target } from "lucide-react";
import { PageHero, PageBody, STATIC_CONTENT, renderInstituteHtml } from "./_shared";
import { usePoly } from "./PolyLayout";

export default function VisionMission() {
  const data = usePoly();
  const inst = data.institute || {};
  const vision = (inst.vision || "").trim() || STATIC_CONTENT.vision;
  const mission = (inst.mission || "").trim() || STATIC_CONTENT.mission;
  return (
    <div data-testid="poly-vision-mission">
      <PageHero eyebrow="Direction" title="Vision & Mission" accent="blue" />
      <PageBody>
        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-blue-700 to-indigo-800 rounded-xl p-8 text-white shadow-xl relative overflow-hidden">
            <div className="absolute -top-10 -right-10 w-40 h-40 bg-amber-400/20 rounded-full blur-3xl" />
            <div className="relative">
              <div className="w-12 h-12 bg-amber-400 rounded-md flex items-center justify-center text-slate-900 mb-4">
                <Eye size={22} strokeWidth={2} />
              </div>
              <h2 className="font-serif text-3xl mb-3">Our Vision</h2>
              <div className="text-white/90 italic leading-relaxed font-serif text-lg prose prose-invert prose-sm max-w-none" data-testid="poly-vision-text" dangerouslySetInnerHTML={{ __html: renderInstituteHtml(vision) }} />
            </div>
          </div>
          <div className="bg-gradient-to-br from-pink-600 to-rose-700 rounded-xl p-8 text-white shadow-xl relative overflow-hidden">
            <div className="absolute -bottom-10 -left-10 w-40 h-40 bg-amber-400/20 rounded-full blur-3xl" />
            <div className="relative">
              <div className="w-12 h-12 bg-amber-400 rounded-md flex items-center justify-center text-slate-900 mb-4">
                <Target size={22} strokeWidth={2} />
              </div>
              <h2 className="font-serif text-3xl mb-3">Our Mission</h2>
              <div className="text-white/90 italic leading-relaxed font-serif text-lg prose prose-invert prose-sm max-w-none" data-testid="poly-mission-text" dangerouslySetInnerHTML={{ __html: renderInstituteHtml(mission) }} />
            </div>
          </div>
        </div>
      </PageBody>
    </div>
  );
}
